<section class="header">
  <div class="header__content">
    <div *ngIf="!isLoggedin" class="header__logo"><a [routerLink]="['/']"><img [src]="imageSrc" [alt]="imageAlt"/></a></div>
    <div *ngIf="isLoggedin && !isAdvertiser" class="header__logo"><a [routerLink]="['/admin/my-profile']"><img [src]="imageSrc" [alt]="imageAlt"/></a></div>
    <div *ngIf="isLoggedin && isAdvertiser" class="header__logo"><img [src]="imageSrc" [alt]="imageAlt"/></div>

    <!-- TODO - we will change ngIf later with isAuth boolean -->

    <div *ngIf="!isLoggedin" class="header__social social">
      <a class="social__text" [routerLink]="[]" (click)="OpenChangeLanguage()">{{ 'HEADER.CHANGE_LANGUAGE' | translate }}</a>
      <!-- <p class="social__text">{{ 'HEADER.SOCIAL_TEXT_MEDIA' | translate }}<br><span>{{ 'HEADER.SOCIAL_TEXT_WEBSITE' | translate }} <a href="https://www.socialite.host">www.socialite.host</a></span></p> -->
      <div class="social__icons">
        <!-- Facebook icon -->
        <a href="https://www.facebook.com/socialite.facebook" target="_blank" class="fb-expand">
          <svg class="fb-gradient" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 257.11 257.11"><defs>
            <linearGradient id="maitred-fb" x1="0%" y1="0%" x2="100%" y2="100%" gradientTransform="rotate(355)">
              <stop offset="0%" style="stop-color:rgb(0,255,255);stop-opacity:1" />
              <stop offset="100%" style="stop-color:rgb(255,0,255);stop-opacity:1" />
            </linearGradient></defs><title>facebook-icon</title>
            <path d="M271,858.69C210.31,848,163.89,795.12,163.89,731.56c0-70.71,57.85-128.56,128.56-128.56S421,660.85,421,731.56c0,63.56-46.42,116.42-107.13,127.13L306.73,853H278.16Z" transform="translate(-163.89 -603)" style="fill:url(#maitred-fb)"/>
            <path d="M342.44,767.27l5.71-35.71H313.87v-25c0-10,3.57-17.86,19.28-17.86h16.43V655.85C340.29,654.42,330.3,653,321,653c-29.28,0-50,17.86-50,50v28.57H238.88v35.71H271V858a108.2,108.2,0,0,0,42.85,0v-90.7Z" transform="translate(-163.89 -603)" style="fill:#fff"/>
          </svg>

          <svg class="fb-black" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
          <style type="text/css">
            .st0{fill:#FFFFFF;}
          </style>
          <circle cx="12" cy="12" r="12"/>
          <g>
            <path class="st0" d="M16.7,15.5l0.5-3.5h-3.3V9.7c0-0.9,0.5-1.9,2-1.9h1.5v-3c0,0-1.4-0.2-2.7-0.2c-2.7,0-4.5,1.7-4.5,4.7V12h-3
              v3.5h3v8.4c0.6,0.1,1.2,0.2,1.9,0.2s1.3-0.1,1.9-0.2v-8.4H16.7z"/>
          </g>
          </svg>
        </a>
        <!-- Instagram icon -->
        <a href="https://www.instagram.com/socialite_event_app/" target="_blank" class="insta-expand">
          <svg class="insta-gradient" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 600 600" style="enable-background:new 0 0 600 600;" xml:space="preserve"><defs>
            <linearGradient id="maitred-insta" x1="0%" y1="0%" x2="100%" y2="100%" gradientTransform="rotate(355)">
              <stop offset="0%" style="stop-color:rgb(0,255,255);stop-opacity:1" />
              <stop offset="100%" style="stop-color:rgb(255,0,255);stop-opacity:1" />
            </linearGradient></defs><title>instagram-icon</title>
            <circle cx="300" cy="300" r="297.5" style="fill:url(#maitred-insta)"/>
            <path class="st0" d="M300,123.5c-47.9,0-54,0.2-72.8,1.1c-18.8,0.9-31.6,3.8-42.8,8.2c-11.6,4.5-21.5,10.5-31.3,20.4
              c-9.8,9.8-15.8,19.7-20.4,31.3c-4.4,11.2-7.4,24.1-8.2,42.8c-0.8,18.8-1.1,24.8-1.1,72.8c0,47.9,0.2,53.9,1.1,72.8
              c0.9,18.8,3.8,31.6,8.2,42.8c4.5,11.6,10.5,21.5,20.4,31.3c9.8,9.8,19.7,15.9,31.3,20.4c11.2,4.4,24.1,7.3,42.8,8.2
              c18.8,0.9,24.8,1.1,72.8,1.1c47.9,0,53.9-0.2,72.8-1.1c18.8-0.9,31.6-3.8,42.9-8.2c11.6-4.5,21.4-10.6,31.2-20.4
              c9.8-9.8,15.8-19.7,20.4-31.3c4.3-11.2,7.3-24,8.2-42.8c0.8-18.8,1.1-24.8,1.1-72.8c0-47.9-0.2-53.9-1.1-72.8
              c-0.9-18.8-3.9-31.6-8.2-42.8c-4.5-11.6-10.6-21.5-20.4-31.3c-9.8-9.8-19.6-15.8-31.3-20.4c-11.3-4.4-24.1-7.3-42.9-8.2
              C353.9,123.7,347.9,123.5,300,123.5L300,123.5z M284.2,155.3c4.7,0,9.9,0,15.8,0c47.1,0,52.7,0.2,71.3,1
              c17.2,0.8,26.5,3.7,32.8,6.1c8.2,3.2,14.1,7,20.3,13.2c6.2,6.2,10,12.1,13.2,20.3c2.4,6.2,5.3,15.6,6.1,32.8
              c0.8,18.6,1,24.2,1,71.3c0,47.1-0.2,52.7-1,71.3c-0.8,17.2-3.7,26.5-6.1,32.8c-3.2,8.2-7,14.1-13.2,20.3c-6.2,6.2-12,10-20.3,13.2
              c-6.2,2.4-15.6,5.3-32.8,6.1c-18.6,0.8-24.2,1-71.3,1c-47.1,0-52.7-0.2-71.3-1c-17.2-0.8-26.5-3.7-32.8-6.1
              c-8.2-3.2-14.1-7-20.3-13.2c-6.2-6.2-10-12.1-13.2-20.3c-2.4-6.2-5.3-15.6-6.1-32.8c-0.8-18.6-1-24.2-1-71.3
              c0-47.1,0.2-52.7,1-71.3c0.8-17.2,3.7-26.5,6.1-32.8c3.2-8.2,7-14.1,13.2-20.3c6.2-6.2,12.1-10,20.3-13.2
              c6.2-2.4,15.6-5.3,32.8-6.1C245,155.5,251.3,155.3,284.2,155.3L284.2,155.3z M394.2,184.6c-11.7,0-21.2,9.5-21.2,21.2
              c0,11.7,9.5,21.2,21.2,21.2c11.7,0,21.2-9.5,21.2-21.2C415.4,194.1,405.9,184.6,394.2,184.6L394.2,184.6z M300,209.4
              c-50.1,0-90.6,40.6-90.6,90.6c0,50.1,40.6,90.6,90.6,90.6c50.1,0,90.6-40.6,90.6-90.6C390.6,249.9,350.1,209.4,300,209.4L300,209.4
              z M300,241.2c32.5,0,58.8,26.3,58.8,58.8c0,32.5-26.3,58.8-58.8,58.8c-32.5,0-58.8-26.3-58.8-58.8
              C241.2,267.5,267.5,241.2,300,241.2z"/>
            <style type="text/css">
              .st0{fill:#FFFFFF;}
            </style>
          </svg>

          <svg class="insta-black" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
          <style type="text/css">
            .st0{fill:#FFFFFF;}
          </style>
          <circle cx="12" cy="12" r="12" style="fill:#000"/>
          <path class="st0" d="M9,4.9h6c2.3,0,4.1,1.8,4.1,4.1v6c0,2.3-1.8,4.1-4.1,4.1H9c-2.3,0-4.1-1.8-4.1-4.1V9C4.9,6.8,6.8,4.9,9,4.9
            M8.9,6.3c-1.4,0-2.6,1.1-2.6,2.6l0,0v6.2c0,1.4,1.1,2.6,2.6,2.6h6.2c1.4,0,2.6-1.1,2.6-2.6c0,0,0,0,0,0V8.9c0-1.4-1.1-2.6-2.6-2.6
            H8.9 M15.7,7.4c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9S15.2,7.4,15.7,7.4 M12,8.5c2,0,3.5,1.6,3.5,3.5
            S14,15.5,12,15.5S8.5,14,8.5,12S10,8.5,12,8.5 M12,9.9c-1.2,0-2.1,1-2.1,2.1s1,2.1,2.1,2.1s2.1-1,2.1-2.1S13.2,9.9,12,9.9z"/>
          </svg>
        </a>
        <!-- Twitter icon -->
        <!-- <a href="http://twitter.com" class="twitter-expand">
          <svg class="twitter-gradient" enable-background="new 0 0 48 48" version="1.1" viewBox="0 0 48 48" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><circle cx="24" cy="24" style="fill:url(#maitred-twitter)" r="24"/>
            <path d="M36.8,15.4c-0.9,0.5-2,0.8-3,0.9c1.1-0.7,1.9-1.8,2.3-3.1c-1,0.6-2.1,1.1-3.4,1.4c-1-1.1-2.3-1.8-3.8-1.8    c-2.9,0-5.3,2.5-5.3,5.7c0,0.4,0,0.9,0.1,1.3c-4.4-0.2-8.3-2.5-10.9-5.9c-0.5,0.8-0.7,1.8-0.7,2.9c0,2,0.9,3.7,2.3,4.7    c-0.9,0-1.7-0.3-2.4-0.7c0,0,0,0.1,0,0.1c0,2.7,1.8,5,4.2,5.6c-0.4,0.1-0.9,0.2-1.4,0.2c-0.3,0-0.7,0-1-0.1    c0.7,2.3,2.6,3.9,4.9,3.9c-1.8,1.5-4.1,2.4-6.5,2.4c-0.4,0-0.8,0-1.3-0.1c2.3,1.6,5.1,2.6,8.1,2.6c9.7,0,15-8.6,15-16.1    c0-0.2,0-0.5,0-0.7C35.2,17.6,36.1,16.6,36.8,15.4z" fill="#FFFFFF"/><defs>
            <linearGradient id="maitred-twitter" x1="0%" y1="0%" x2="100%" y2="100%" gradientTransform="rotate(355)">
              <stop offset="0%" style="stop-color:rgb(0,255,255);stop-opacity:1" />
              <stop offset="100%" style="stop-color:rgb(255,0,255);stop-opacity:1" />
            </linearGradient></defs><title>twitter-icon</title>
          </svg>

          <svg class="twitter-black" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
          <style type="text/css">
            .st0{fill:#FFFFFF;}
          </style>
          <circle cx="12" cy="12" r="12"/>
          <path class="st0" d="M19.4,7.8c-0.5,0.2-1.1,0.4-1.7,0.5c0.6-0.4,1.1-1,1.3-1.7c-0.6,0.4-1.2,0.6-1.9,0.7c-0.6-0.6-1.3-1-2.2-1
            c-1.7,0-3,1.4-3,3c0,0.2,0,0.5,0.1,0.7C9.4,10,7.1,8.7,5.7,6.9c-0.3,0.4-0.4,1-0.4,1.5c0,1,0.5,2,1.3,2.5c-0.5,0-1-0.1-1.4-0.4
            c0,0,0,0,0,0c0,1.5,1,2.7,2.4,3c-0.3,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.4,0-0.6-0.1c0.4,1.2,1.5,2.1,2.8,2.1c-1,0.8-2.3,1.3-3.8,1.3
            c-0.2,0-0.5,0-0.7,0c1.3,0.9,2.9,1.4,4.6,1.4c5.5,0,8.6-4.6,8.6-8.6c0-0.1,0-0.3,0-0.4C18.5,8.9,19,8.4,19.4,7.8z"/>
          </svg>
        </a> -->
      </div>
    </div>

    <div *ngIf="isLoggedin" class="header__user user">
      <div *ngIf="isAdvertiser" class="div_products">
        <div class="products_dropdown" (click)="menu_products.toggle($event)">
          <i class="pi c-icons-white menu-icon"></i>
        </div>
      </div>
      <div class="user__info">
        <div class="user__name">{{ firstName}} {{ lastName }}</div>
        <div *ngIf="isAdvertiser" class="user__role">
          <img src="assets/images/icons/the-crown.svg">
          General Manager
        </div>
        <div *ngIf="!isAdvertiser && !isTechSupport" class="user__role">
          <img src="assets/images/icons/the-crown.svg">
          Super Admin
        </div>
        <div *ngIf="!isAdvertiser && isTechSupport" class="user__role">
          <img src="assets/images/icons/the-crown.svg">
          Techincal Support
        </div>
      </div>
      <div class="dropdown">
          <div class="user__image dropbtn">
            <img src={{imagePath}} alt="profile-picture">
          </div>
      </div>
      <app-chat-sidebar *ngIf="isAdvertiser"></app-chat-sidebar>
      <button style="text-align: right;" mat-button [matMenuTriggerFor]="menu"><mat-icon>menu</mat-icon></button>
      <mat-menu xPosition="before" class="custom-menu" #menu="matMenu">
        <button mat-menu-item (click)="OpenChangeLanguage()">{{ 'HEADER.CHANGE_LANGUAGE' | translate }}</button>
        <button mat-menu-item (click)="OpenPrivacyPolicy()">{{ 'HEADER.PRIVACY_POLICY' | translate }}</button>
        <button mat-menu-item (click)="OpenFAQ()">{{ 'HEADER.FAQ' | translate }}</button>

        <!-- <button mat-menu-item>{{ 'HEADER.CHANGE_THEME' | translate }}</button> -->
        <button class="no-border" mat-menu-item (click)="signOut()">{{ 'HEADER.LOG_OUT' | translate }}</button>
      </mat-menu>
    </div>
  </div>
</section>
<ng-container>
  <p-overlayPanel #menu_products styleClass="products-menu" id="menu_products"
     [dismissable]="true">
    <div (click)="$event.stopPropagation()">
      <ng-container *ngIf="productList.length > 0">
        <div class="products-container">
          <div *ngFor="let product of productList" class="div-card-product cursor-pointer" (click)="goToProductUrl(product.url)">
            <div class="d-flex flex-wrap justify-content-center logo-container">
              <img class="product-logo" [src]="product.pictureUrl" alt="profile-picture">
            </div>
          </div>
        </div>
      </ng-container>
      <div class="p-menuitem-link" (click)="goToDashboard();">{{'HEADER.GO_TO_DASHBOARD' | translate}}</div>
    </div>
  </p-overlayPanel>
</ng-container>
